import { render } from "./ProjectFiles.vue?vue&type=template&id=0a49e531"
import script from "./ProjectFiles.vue?vue&type=script&lang=js"
export * from "./ProjectFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__